const $ = require('jquery');
const cookieUtils = require('cookie-utils');

const config = {
  pcSiteLink: '#linkPcSite',
};

class PcLink {
  _clickHandler(event) {
    event.preventDefault();
    cookieUtils.setCookieExpireInSeconds(
      'THD_USR_AGENT_OVERRIDE',
      'FULL',
      18000,
      window.THD_GLOBAL.cookie_domain,
    );
    cookieUtils.deleteBrowserCookie(
      'THD_ONLINE_CHANNEL',
      window.THD_GLOBAL.cookie_domain,
    );
    cookieUtils.deleteBrowserCookie(
      'MOBILE_WEB',
      window.THD_GLOBAL.cookie_domain,
    );

    let pcSiteUrl = '';
    let absoluteUrlPattern = /^https?:\/\//i;
    if (typeof window.THD_GLOBAL.deepLinkUrl === 'undefined') {
      pcSiteUrl = $(config.pcSiteLink).data('href');
    } else if (!absoluteUrlPattern.test(window.THD_GLOBAL.deepLinkUrl)) {
      pcSiteUrl =
        $(config.pcSiteLink).data('href') + window.THD_GLOBAL.deepLinkUrl;
    } else {
      pcSiteUrl = window.THD_GLOBAL.deepLinkUrl;
    }
    window.location.assign(pcSiteUrl);
  }

  init() {
    $(config.pcSiteLink).on('click touchend', this._clickHandler);
  }
}

module.exports = new PcLink();
